/**
 * Shared runtime constants for the prebooking registration flow (CCT-2060).
 * Centralised here so they can be reused across composables and services
 * without duplication.
 */

/** Process key used by the consents service for registration consent validation. */
export const REGISTRATION_CONSENT_PROCESS = 'REGISTRATION-xs3N'

/**
 * sessionStorage keys used by the pre-booking OIDC registration flow (CCT-2060).
 * Kept in this dependency-free module (rather than in usePrebookingOidcRegistration.ts,
 * which imports usePersonalStore) so that stores/personal.ts can clear them
 * without creating a store <-> composable circular import.
 */
export const SESSION_KEY_REG_DATA = 'prebooking_reg_data'
export const SESSION_KEY_PKCE_VERIFIER = 'prebooking_pkce_verifier'
export const SESSION_KEY_OAUTH_STATE = 'prebooking_oauth_state'

/** Clears all sessionStorage keys owned by the OIDC registration flow. */
export function clearOidcSessionData() {
  sessionStorage.removeItem(SESSION_KEY_PKCE_VERIFIER)
  sessionStorage.removeItem(SESSION_KEY_REG_DATA)
  sessionStorage.removeItem(SESSION_KEY_OAUTH_STATE)
}
